import { FC } from 'react';
import { Lock, Play } from 'lucide-react';

interface LessonCardHeaderProps {
  isLocked?: boolean;
}

export const LessonCardHeader: FC<LessonCardHeaderProps> = ({
  isLocked = false,
}) => {
  return (
    <div className="relative h-40 bg-gradient-to-br from-dashboard-kids-primary via-dashboard-kids-secondary to-accent overflow-hidden group">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-black/40 backdrop-blur-sm p-3 rounded-full transition-all duration-500 group-hover:scale-110">
          {isLocked ? (
            <Lock className="w-8 h-8 text-white" />
          ) : (
            <Play className="w-8 h-8 text-white" fill="white" />
          )}
        </div>
      </div>
    </div>
  );
};